import { CHECKOUT_API_KEY } from '../../constants';

export const NAME = 'googlepay';

export const REQUEST_GOOGLE_PAY = 'REQUEST_GOOGLE_PAY';
export const SUCCESS_GOOGLE_PAY = 'SUCCESS_GOOGLE_PAY';
export const FAILURE_GOOGLE_PAY = 'FAILURE_GOOGLE_PAY';

export const baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0
};
export const tokenizationSpecification = {
    type: 'PAYMENT_GATEWAY',
    parameters: {
        gateway: 'checkoutltd',
        gatewayMerchantId: CHECKOUT_API_KEY
    }
};

export const baseCardPaymentMethod = {
    type: 'CARD',
    parameters: {
        allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
        allowedCardNetworks: ['MASTERCARD', 'VISA']
    }
};

export const cardPaymentMethod = Object.assign(
    { tokenizationSpecification: tokenizationSpecification },
    baseCardPaymentMethod
);



// WEBPACK FOOTER //
// ./src/services/googlepay/constants.js